import { CC_ONBOARDING_FORM_PHONE, CC_ONBOARDING_FORM_PHONE_VERIFY } from 'components/features/creditCard/creditCardOnboarding/constants'
import { ajaxCatch } from 'rxOperators/ajaxCatch'
import { filterRequest, filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { getResponseFormErrors } from 'helpers/ajaxHelpers'
import { Epic } from 'interfaces/middleware'
import { startSubmit, stopSubmit } from 'redux-form'
import { of, merge, EMPTY } from 'rxjs'
import { mergeMap, takeUntil } from 'rxjs/operators'
import { PatchCCOnboardingPropsAction, CreateCCPhoneAction, VerifyCCPhoneAction } from 'components/features/creditCard/creditCardStore/actions'
import { CC_ONBOARDING_PHONE_CREATE_URL, CC_ONBOARDING_PHONE_VERIFY_URL } from 'components/features/creditCard/creditCardStore/endpoints'


export const createCCPhoneEpic: Epic = (action$, _, { post }) => action$.pipe(
  filterRequest(CreateCCPhoneAction.type),
  mergeMap((action) => {
    const { phone_number } = action.payload.params.person_data

    return merge(
      of(startSubmit(CC_ONBOARDING_FORM_PHONE)),
      post(CC_ONBOARDING_PHONE_CREATE_URL, { body: { phone_number }}).pipe(
        mergeMap(({ response, xhr }) => {
          const success$ = of(action.success({
            ...response,
            'x-ratelimit-reset': xhr.getResponseHeader('x-ratelimit-reset'),
          }))

          if (response.is_verified) {
            return merge(
              success$,
              of(new PatchCCOnboardingPropsAction(action.payload.params)),
              action$.pipe(
                filterRequestOfType(PatchCCOnboardingPropsAction.type, 'fail'),
                takeUntil(
                  action$.pipe(
                    filterRequest(PatchCCOnboardingPropsAction.type),
                  )
                ),
                mergeMap((patchFailAction) => {
                  const errRes = getResponseFormErrors(patchFailAction.payload.errorsMap)
                  return of(stopSubmit(CC_ONBOARDING_FORM_PHONE, errRes))
                })
              )
            )
          }

          return success$
        }),
        ajaxCatch((error) => of(action.fail({
          errorCode: error.status,
          errorsMap: error.response,
          'x-ratelimit-reset': error.xhr.getResponseHeader('x-ratelimit-reset'),
        })))
      )
    )
  }),
)

export const createCCPhoneFailEpic: Epic = (action$) => action$.pipe(
  filterRequestOfType(CreateCCPhoneAction.type, 'fail'),
  mergeMap((action) => {
    const { errorCode } = action.payload
    let { errorsMap } = action.payload
    if (errorCode === 429) {
      errorsMap = {
        non_field_errors: ['Too Many Requests'],
      }
    }
    if (!errorsMap) {
      return EMPTY
    }

    const errRes = getResponseFormErrors(errorsMap)
    return of(stopSubmit(CC_ONBOARDING_FORM_PHONE, errRes))
  })
)

export const verifyCCPhoneEpic: Epic = (action$, _, { post }) => action$.pipe(
  filterRequest(VerifyCCPhoneAction.type),
  mergeMap((action) => {

    return merge(
      of(startSubmit(CC_ONBOARDING_FORM_PHONE_VERIFY)),
      post(CC_ONBOARDING_PHONE_VERIFY_URL, { body: action.payload.params.verify }).pipe(
        mergeMap(({ response }) => {
          if (response.is_verified) {
            return merge(
              of(action.success(response)),
              of(new PatchCCOnboardingPropsAction(action.payload.params.patch)),
              action$.pipe(
                filterRequestOfType(PatchCCOnboardingPropsAction.type, 'fail'),
                takeUntil(
                  action$.pipe(
                    filterRequest(PatchCCOnboardingPropsAction.type),
                  )
                ),
                mergeMap((patchFailAction) => {
                  const { person_data, ...restErrors } = patchFailAction.payload.errorsMap || {} as any

                  const errRes = getResponseFormErrors({
                    ...restErrors,
                    ...(person_data || {}),
                  })

                  return of(stopSubmit(CC_ONBOARDING_FORM_PHONE_VERIFY, errRes))
                })
              )
            )
          }

          return of(action.fail({ errorCode: 200,
            errorsMap: {
              verification_code: ['incorrect'],
            }}))
        }),
        ajaxCatch((error) => {
          const { phone_number, ...restErrorsMap } = error.response

          if (phone_number) {
            restErrorsMap['non_field_errors'] = phone_number
          }

          return of(action.fail({ errorCode: error.status, errorsMap: restErrorsMap }))
        })
      )
    )
  })
)

export const verifyCCPhoneFailEpic: Epic = (action$) => action$.pipe(
  filterRequestOfType(VerifyCCPhoneAction.type, 'fail'),
  mergeMap((action) => {
    const errRes = getResponseFormErrors(action.payload.errorsMap)
    return of(stopSubmit(CC_ONBOARDING_FORM_PHONE_VERIFY, errRes))
  })
)
